import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './Toast_DependencyConflictNotification.scss';
import { dispatch_onDeleteConflicts } from '../../dispatchers.js';
export const Toast_DependencyResolutionNotification = (props) => {
    const renderResolveDependenciesPanel = () => {
        dispatch_onDeleteConflicts.dispatchUI(props.errorData);
    };
    return _jsxs("div", { className: 'flex-toast-base', children: [_jsx("div", { children: "Entity has dependencies." }), _jsxs("div", { onClick: () => renderResolveDependenciesPanel(), children: [_jsx("span", { className: 'click-here-label', children: "Click here" }), " to resolve"] })] });
};
//# sourceMappingURL=Toast_DependencyConflictNotification.js.map